import React from "react"
import {Box, Tooltip} from "@mui/material"
import ProgressBar from 'src/v2/pages/MotorCadastros/components/ProgressBar/progress-bar'
import {renderCellDateTime} from "src/utils/table-render-functions"
import StatusBadge from "../../../../components/StatusBadge"
import ButtonWithIcon from "../../../../components/Button/Button"
import {ReactComponent as DownloadIcon} from "../../../../assets/icons/download-icon.svg"

const calculaPorcentagem = (params) => {
    const {
        row: {total_registros, total_registros_processados}
    } = params
    if (!total_registros || !total_registros_processados) return 0
    const porcentagem = (total_registros_processados / total_registros) * 100

    if (porcentagem == null || Number.isNaN(Number(porcentagem))) {
        return 0
    }
    return Number(porcentagem.toFixed(2))
}

const tooltipRegistros = (params) => {
    const {row: {total_registros, total_registros_processados}} = params
    const message =
        total_registros == null && total_registros_processados == null
            ? "Registros Não Informados"
            : `Total Registros: ${total_registros ?? 0} | Registros Processados: ${total_registros_processados ?? 0}`

    return <Tooltip
        placement="right"
        title={message}>
        <Box
            sx={{
                width: "100%",
                py: 1.5,
                pr: 2,
            }}
        >
            <ProgressBar value={calculaPorcentagem(params)}/>
        </Box>
    </Tooltip>
}

const chipStatus = (params) => {
    const {row: {status}} = params
    const map = {
        REPORT_DONE: {
            label: "FINALIZADO",
            color: "success"
        },
        PROCESS_DONE: {
            label: "FINALIZADO",
            color: "success"
        },
        ERROR: {
            label: "ERRO",
            color: "error"
        },
        PROCESSING: {
            label: "EM ANDAMENTO",
            color: "warning"
        },
        SETUP_TASK: {
            label: "INICIANDO",
            color: "warning"
        },
        PENDING: {
            label: "PENDENTE",
            color: "warning"
        }
    }

    const label = map[status].label || status
    const color = map[status].color || "warning"

    return <StatusBadge label={label} backgroundColor={color}/>
}

const possuiRelatorio = (reportPath) => {
    if (!reportPath) return false

    if (typeof reportPath === "object") {
        return Boolean(reportPath.file_name)
    }

    if (typeof reportPath !== "string") {
        return false
    }

    try {
        const reportPathNormalizado = reportPath
            .replace(/\bNone\b/g, "null")
            .replace(/'/g, "\"")

        const report = JSON.parse(reportPathNormalizado)

        return Boolean(report.file_name)
    } catch {
        return false
    }
}

const downloadReport = (params, downloadFunction) => {
    const {row : {report_path, id}} = params
    
    let disabledButton = !possuiRelatorio(report_path)

    return <ButtonWithIcon icon={<DownloadIcon/>} disabled={disabledButton} onClick={() => downloadFunction(id)}/>
}

export const cadastroLoteColumnsTable = (downloadFunction) => [
    {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => chipStatus(params),
    },
    {
        field: "total_registros",
        headerName: "Total Registros",
        flex: 1,
        minWidth: 140,
    },
    {
        field: "progresso",
        headerName: "Progresso",
        flex: 1,
        minWidth: 180,
        sortable: false,
        renderCell: (params) => tooltipRegistros(params),
    },
    {
        field: "logErro",
        headerName: "Log Erro",
        flex: 1,
        minWidth: 140,
        renderCell: (params) => downloadReport(params, downloadFunction),
    },
    {
        field: "nome_usuario",
        headerName: "Usuário",
        flex: 1,
        minWidth: 200,
    },
    {
        field: "criado_em",
        headerName: "Data Criação",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "atualizado_em",
        headerName: "Data Atualização",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => renderCellDateTime(params)
    },
]
